/* FireMate theme.js — no dependencies. */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = {};
  try { cfg = JSON.parse(d.getElementById('shop-json').textContent); } catch (e) {}

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function on(el, ev, fn, o) { el && el.addEventListener(ev, fn, o); }
  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    var amount = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','))
      .replace(/<[^>]+>/g, '');
  }
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.hidden = true; }, 300); }, 2600);
  }
  function bump(el) { if (!el) return; el.classList.add('is-bump'); setTimeout(function () { el.classList.remove('is-bump'); }, 250); }
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw j; } return j; });
    });
  }

  /* ---------- header ---------- */
  var header = $('.header');
  function headerState() { header && header.classList.toggle('is-scrolled', w.scrollY > 8); }
  on(w, 'scroll', headerState, { passive: true }); headerState();

  /* ---------- mobile menu ---------- */
  var menu = $('#menu'), menuOpen = $('#menu-open'), menuClose = $('#menu-close');
  function setMenu(open) {
    if (!menu) return;
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuOpen && menuOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    d.body.style.overflow = open ? 'hidden' : '';
    if (open) { (menuClose || menu).focus(); } else { menuOpen && menuOpen.focus(); }
  }
  on(menuOpen, 'click', function () { setMenu(true); });
  on(menuClose, 'click', function () { setMenu(false); });
  on(menu, 'click', function (e) { if (e.target.closest('a')) setMenu(false); });
  on(d, 'keydown', function (e) { if (e.key === 'Escape') { setMenu(false); closeDrawer(); } });

  /* ---------- reveal ---------- */
  $$('.words').forEach(function (el) {
    var text = el.textContent.trim().split(/\s+/);
    el.innerHTML = text.map(function (wd) { return '<span class="w"><span>' + wd + '</span></span>'; }).join(' ');
  });
  if ('IntersectionObserver' in w && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('[data-reveal],[data-reveal-stagger],.words').forEach(function (el) { io.observe(el); });
  } else {
    $$('[data-reveal],[data-reveal-stagger],.words').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- hero parallax ---------- */
  var heroProduct = $('.hero__product'), hero = $('.hero');
  if (heroProduct && hero && !reduce && w.matchMedia('(pointer:fine)').matches) {
    var hx = 0, hy = 0, tx = 0, ty = 0, raf;
    on(hero, 'mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 18; ty = ((e.clientY - r.top) / r.height - 0.5) * 12;
      if (!raf) raf = requestAnimationFrame(tick);
    });
    on(hero, 'mouseleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(tick); });
    function tick() {
      hx += (tx - hx) * 0.12; hy += (ty - hy) * 0.12;
      heroProduct.style.transform = 'translateX(-50%) translate(' + hx.toFixed(2) + 'px,' + hy.toFixed(2) + 'px) rotate(' + (hx * 0.08).toFixed(2) + 'deg)';
      raf = (Math.abs(tx - hx) > 0.05 || Math.abs(ty - hy) > 0.05) ? requestAnimationFrame(tick) : null;
    }
  }

  /* ---------- marquee ---------- */
  $$('.marquee__track').forEach(function (track) {
    var g = $('.marquee__group', track); if (!g) return;
    var clone = g.cloneNode(true); clone.setAttribute('aria-hidden', 'true'); track.appendChild(clone);
  });

  /* ---------- anatomy hotspots ---------- */
  var anatomy = $('.anatomy');
  if (anatomy) {
    var items = $$('.anatomy__item', anatomy), spots = $$('.hotspot', anatomy);
    function activate(i) {
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
      spots.forEach(function (sp, k) { sp.classList.toggle('is-active', k === i); sp.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    }
    activate(0);
    if ('IntersectionObserver' in w) {
      var aio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) activate(items.indexOf(e.target)); });
      }, { rootMargin: '-40% 0px -45% 0px', threshold: 0 });
      items.forEach(function (it) { aio.observe(it); });
    }
    spots.forEach(function (sp, k) {
      on(sp, 'click', function () {
        activate(k);
        if (w.matchMedia('(max-width: 900px)').matches) { items[k].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
        else { var top = items[k].getBoundingClientRect().top + w.scrollY - w.innerHeight * 0.42; w.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); }
      });
    });
  }

  /* ---------- growth rings (Raleigh) ---------- */
  var cv = $('#rings');
  if (cv && cv.getContext) {
    var ctx = cv.getContext('2d'), dpr = Math.min(2, w.devicePixelRatio || 1), size = 620;
    cv.width = size * dpr; cv.height = size * dpr;
    var labels = (cv.getAttribute('data-labels') || '').split('|').filter(Boolean);
    var seed = 11;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    var wob = []; for (var k = 0; k < 64; k++) wob.push({ a: rnd() * Math.PI * 2, f: 1 + Math.floor(rnd() * 4), m: rnd() });
    function radius(base, t, wi) { var r = base; for (var i = 0; i < 6; i++) { var o = wob[(wi * 6 + i) % wob.length]; r += Math.sin(t * o.f + o.a) * o.m * base * 0.03; } return r; }
    var groups = 5, per = 6, total = groups * per + 2;
    function draw(prog) {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, size, size);
      var cx = size / 2, cy = size / 2, maxR = size * 0.47, idx = 0;
      for (var g = 0; g < groups; g++) {
        for (var s = 0; s < per; s++) {
          var frac = (idx + 1) / total; idx++;
          if (frac > prog + 0.02) continue;
          var base = maxR * (g * per + s + 5) / (total + 3);
          var a = 1 - Math.max(0, frac - prog + 0.02) / 0.04;
          ctx.beginPath();
          for (var t = 0; t <= Math.PI * 2 + 0.01; t += 0.02) { var r = radius(base, t, g * per + s); var px = cx + Math.cos(t) * r, py = cy + Math.sin(t) * r; t === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py); }
          ctx.closePath();
          var main = s === per - 1;
          ctx.strokeStyle = main ? 'rgba(227,201,154,' + (0.92 * a) + ')' : 'rgba(244,242,237,' + ((0.13 + s * 0.03) * a) + ')';
          ctx.lineWidth = main ? 1.6 : 1; ctx.stroke();
        }
      }
      if (prog >= 0.98 && labels.length) {
        ctx.font = '500 11px "JetBrains Mono", ui-monospace, monospace'; ctx.fillStyle = 'rgba(216,50,31,1)'; ctx.textBaseline = 'middle';
        var ang = -Math.PI / 4;
        for (var l = 0; l < labels.length && l < groups; l++) {
          var rr = maxR * (l * per + per + 4) / (total + 3);
          var lx = cx + Math.cos(ang) * rr, ly = cy + Math.sin(ang) * rr;
          ctx.fillRect(lx - 2, ly - 2, 4, 4);
          ctx.fillStyle = 'rgba(227,201,154,1)'; ctx.fillText(labels[l], lx + 8, ly - 9); ctx.fillStyle = 'rgba(216,50,31,1)';
        }
      }
    }
    var started = false;
    function startRings() {
      if (started) return; started = true;
      if (reduce) { draw(1); return; }
      var t0 = null;
      (function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 2400); draw(p); if (p < 1) requestAnimationFrame(step); })(performance.now());
    }
    if ('IntersectionObserver' in w) { var rio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) startRings(); }); }, { threshold: 0.3 }); rio.observe(cv); }
    else startRings();
  }

  /* ---------- Raleigh clock ---------- */
  var clocks = $$('[data-clock]');
  if (clocks.length) {
    function tickClock() {
      var s = '';
      try { s = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: '2-digit', hour12: true }).format(new Date()) + ' ET'; } catch (e) {}
      clocks.forEach(function (c) { c.textContent = s; });
    }
    tickClock(); setInterval(tickClock, 15000);
  }

  /* ---------- to-top ring ---------- */
  var toTop = $('#to-top');
  if (toTop) {
    function prog() {
      var h = d.documentElement, max = h.scrollHeight - h.clientHeight, p = max > 0 ? w.scrollY / max : 0;
      toTop.style.setProperty('--p', p.toFixed(3)); toTop.classList.toggle('is-visible', w.scrollY > 600);
    }
    on(w, 'scroll', prog, { passive: true }); prog();
    on(toTop, 'click', function () { w.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  }

  /* ---------- quantity steppers (delegated) ---------- */
  on(d, 'click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b) return;
    var wrap = b.closest('.qty'), input = $('input', wrap); if (!input) return;
    var v = parseInt(input.value, 10) || 1, min = parseInt(input.min, 10) || 1;
    v = b.getAttribute('data-qty') === '+' ? v + 1 : Math.max(min, v - 1);
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart ---------- */
  var drawer = $('#cart-drawer');
  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden';
    var c = $('#cart-drawer-close'); c && c.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return;
    drawer.setAttribute('aria-hidden', 'true'); d.body.style.overflow = '';
  }
  on(d, 'click', function (e) {
    if (e.target.closest('[data-cart-open]')) { if (drawer && cfg.cartType !== 'page') { e.preventDefault(); refreshDrawer().then(openDrawer); } }
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.classList.toggle('is-visible', count > 0); });
  }
  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    drawer.classList.add('is-busy');
    return fetch(cfg.rootUrl + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var tmp = d.createElement('div'); tmp.innerHTML = j['cart-drawer'];
      var fresh = $('#cart-drawer', tmp) || tmp;
      var body = $('.drawer__panel', fresh), cur = $('.drawer__panel', drawer);
      if (body && cur) cur.innerHTML = body.innerHTML;
      var cnt = $('[data-cart-total-count]', drawer); if (cnt) updateCount(parseInt(cnt.getAttribute('data-cart-total-count'), 10) || 0);
    }).catch(function () {}).then(function () { drawer.classList.remove('is-busy'); });
  }
  function refreshCartPage() {
    var page = $('#main-cart'); if (!page) return Promise.resolve();
    var id = page.getAttribute('data-section-id');
    return fetch(w.location.pathname + '?sections=' + id).then(function (r) { return r.json(); }).then(function (j) {
      var tmp = d.createElement('div'); tmp.innerHTML = j[id];
      var fresh = $('#main-cart', tmp); if (fresh) page.innerHTML = fresh.innerHTML;
    });
  }
  function addToCart(items, btn) {
    btn && btn.classList.add('is-loading');
    return fetchJSON(cfg.cartAddUrl + '.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .then(function () { return fetchJSON(cfg.cartUrl + '.js'); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (cfg.cartType === 'page') { toast('Added to cart'); return refreshDrawer(); }
        return refreshDrawer().then(openDrawer);
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); })
      .then(function () { btn && btn.classList.remove('is-loading'); });
  }
  function changeLine(key, qty) {
    drawer && drawer.classList.add('is-busy');
    return fetchJSON(cfg.cartChangeUrl + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (cart) { updateCount(cart.item_count); return Promise.all([refreshDrawer(), refreshCartPage()]); })
      .catch(function (err) { toast((err && err.description) || 'Could not update cart'); })
      .then(function () { drawer && drawer.classList.remove('is-busy'); });
  }
  on(d, 'click', function (e) {
    var rm = e.target.closest('[data-line-remove]'); if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-line-remove'), 0); }
  });
  on(d, 'change', function (e) {
    var inp = e.target.closest('[data-line-qty]'); if (inp) { changeLine(inp.getAttribute('data-line-qty'), Math.max(0, parseInt(inp.value, 10) || 0)); }
  });
  /* product forms (PDP) */
  on(d, 'submit', function (e) {
    var f = e.target.closest('form[data-product-form]'); if (!f) return;
    e.preventDefault();
    var id = $('[name="id"]', f).value, q = parseInt(($('[name="quantity"]', f) || {}).value, 10) || 1;
    addToCart([{ id: parseInt(id, 10), quantity: q }], $('[type="submit"]', f));
  });

  /* ---------- bundle builder ---------- */
  var builder = $('#builder');
  if (builder) {
    var data = {};
    try { data = JSON.parse($('#builder-data').textContent); } catch (e) {}
    var variants = data.variants || [], opt1 = data.option1 || [], opt2 = data.option2 || [];
    var totalEl = $('[data-total]', builder), linesEl = $('[data-lines]', builder), qtyIn = $('[data-builder-qty]', builder),
        addBtn = $('[data-builder-add]', builder), unav = $('[data-unavailable]', builder), shipEl = $('[data-ship-note]', builder), variantEl = $('[data-variant-title]', builder);
    var basePrice = null;
    variants.forEach(function (v) { if (v.option2 === opt2[0] && v.option1 === opt1[0]) basePrice = v.price; });
    function selected(name) { var el = $('input[name="' + name + '"]:checked', builder); return el ? el.value : null; }
    function findVariant(o1, o2) { for (var i = 0; i < variants.length; i++) { if (variants[i].option1 === o1 && variants[i].option2 === o2) return variants[i]; } return null; }
    function updateDeltas() {
      var o1 = selected('fm-stand'), o2 = selected('fm-ext');
      $$('input[name="fm-stand"]', builder).forEach(function (inp) {
        var v = findVariant(inp.value, opt2[0]), p = $('[data-price]', inp.parentNode);
        if (v && p) p.textContent = money(v.price);
        inp.disabled = !v || !v.available;
      });
      $$('input[name="fm-ext"]', builder).forEach(function (inp) {
        var base = findVariant(o1, opt2[0]), v = findVariant(o1, inp.value), p = $('[data-price]', inp.parentNode);
        if (v && base && p) { var dlt = v.price - base.price; p.textContent = dlt > 0 ? '+ ' + money(dlt) : (dlt === 0 ? 'Included' : '− ' + money(-dlt)); }
        inp.disabled = !v || !v.available;
      });
    }
    function render() {
      var o1 = selected('fm-stand'), o2 = selected('fm-ext'), q = Math.max(1, parseInt(qtyIn.value, 10) || 1);
      var v = findVariant(o1, o2), base = findVariant(o1, opt2[0]);
      updateDeltas();
      if (!v) { addBtn.setAttribute('aria-disabled', 'true'); unav.hidden = false; return; }
      var standPrice = base ? base.price : v.price, extPrice = v.price - standPrice;
      var lines = '<div class="summary__line"><span>' + esc(o1) + (q > 1 ? ' × ' + q : '') + '</span><span>' + money(standPrice * q) + '</span></div>';
      if (o2 !== opt2[0]) lines += '<div class="summary__line is-free"><span>' + esc(o2) + (q > 1 ? ' × ' + q : '') + '</span><span>' + money(extPrice * q) + '</span></div>';
      linesEl.innerHTML = lines;
      totalEl.textContent = money(v.price * q); bump(totalEl);
      variantEl && (variantEl.textContent = v.title);
      shipEl.innerHTML = o2 !== opt2[0] ? '<b>Extinguisher ships free.</b> Stand shipping is calculated at checkout.' : 'Shipping for the stand is calculated at checkout. Add an extinguisher and it ships free.';
      addBtn.setAttribute('data-variant-id', v.id);
      addBtn.setAttribute('aria-disabled', v.available ? 'false' : 'true');
      unav.hidden = v.available;
    }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    on(builder, 'change', function (e) { if (e.target.matches('input[name="fm-stand"],input[name="fm-ext"],[data-builder-qty]')) render(); });
    on(addBtn, 'click', function () {
      if (addBtn.getAttribute('aria-disabled') === 'true') return;
      addToCart([{ id: parseInt(addBtn.getAttribute('data-variant-id'), 10), quantity: Math.max(1, parseInt(qtyIn.value, 10) || 1) }], addBtn);
    });
    render();
  }

  /* ---------- product page: variants + gallery ---------- */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var pvariants = [];
    try { pvariants = JSON.parse($('#pdp-variants').textContent); } catch (e) {}
    var form = $('form[data-product-form]', pdp), idIn = form && $('[name="id"]', form), priceEl = $('[data-pdp-price]', pdp), cmpEl = $('[data-pdp-compare]', pdp),
        submit = form && $('[type="submit"]', form), submitLbl = submit && $('.btn__label', submit), slides = $$('.gallery__slide', pdp), thumbs = $$('.gallery__thumb', pdp);
    function selectedOptions() { return $$('.variants', pdp).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function matchVariant() {
      var sel = selectedOptions();
      for (var i = 0; i < pvariants.length; i++) { var v = pvariants[i], ok = true; for (var k = 0; k < sel.length; k++) { if (v.options[k] !== sel[k]) { ok = false; break; } } if (ok) return v; }
      return null;
    }
    function showSlide(i) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, k) { on(t, 'click', function () { showSlide(k); }); });
    function updateVariant() {
      var v = matchVariant();
      $$('.variants', pdp).forEach(function (g) { var lbl = $('[data-selected]', g), c = $('input:checked', g); if (lbl && c) { var sp = c.parentNode.querySelector('span'); lbl.textContent = sp ? sp.textContent : c.value; } });
      if (!v) { submit && submit.setAttribute('disabled', ''); submitLbl && (submitLbl.textContent = 'Unavailable'); return; }
      idIn && (idIn.value = v.id);
      priceEl && (priceEl.textContent = money(v.price)); bump(priceEl);
      if (cmpEl) { if (v.compare_at_price && v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false; } else cmpEl.hidden = true; }
      if (submit) { if (v.available) { submit.removeAttribute('disabled'); submitLbl && (submitLbl.textContent = submit.getAttribute('data-label-add') || 'Add to cart'); } else { submit.setAttribute('disabled', ''); submitLbl && (submitLbl.textContent = 'Sold out'); } }
      if (v.featured_media_id) { var idx = -1; slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(v.featured_media_id)) idx = k; }); if (idx > -1) showSlide(idx); }
      if (history.replaceState) { var u = new URL(w.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      $$('[data-pdp-sku]', pdp).forEach(function (el) { el.textContent = v.sku || '—'; });
    }
    on(pdp, 'change', function (e) { if (e.target.closest('.variants')) updateVariant(); });
    if (pvariants.length > 1) updateVariant();
  }

  /* ---------- FAQ: close others (accordion behaviour, optional) ---------- */
  $$('.faq__list').forEach(function (list) {
    on(list, 'toggle', function (e) {
      if (e.target.open) $$('details[open]', list).forEach(function (o) { if (o !== e.target) o.open = false; });
    }, true);
  });

  /* ---------- initial cart count ---------- */
  var cc = $('[data-cart-count]'); if (cc) updateCount(parseInt(cc.textContent, 10) || 0);
})();
